module.exports = __webpack_public_path__ + "img/ru_Ecran 3.026a56d8.png";